import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["search", "searchedBrand", "searchedBrandUrl", "searchedBrandUrlText", "searchedBrandNoUrl", "searchedBrandPage"]

  // Show the website and SkinSort page of the brand found with the duplicate search
  showSearchedBrand() {
    const searchSelect = this.searchTarget.tomselect
    const brand = searchSelect?.options[searchSelect.getValue()]

    this.searchedBrandTarget.classList.toggle('hidden', !brand)
    if (!brand) return

    const url = brand.url || ''
    this.searchedBrandUrlTarget.classList.toggle('hidden', !url)
    this.searchedBrandNoUrlTarget.classList.toggle('hidden', !!url)
    this.searchedBrandUrlTarget.href = url || '#'
    this.searchedBrandUrlTextTarget.textContent = url.replace(/^https?:\/\/(www\.)?/, '').replace(/\/$/, '')

    this.searchedBrandPageTarget.href = brand.path
  }

  openModal(event) {
    const brandId = event.currentTarget.dataset.brandId
    const brandName = event.currentTarget.dataset.brandName

    const form = document.getElementById('duplicate-form')
    if (form) {
      form.action = `/admin/brands/${brandId}/duplicate`
    }

    this.prefillExistingBrand()

    window.dispatchEvent(new CustomEvent('open-duplicate-modal', {
      detail: { brandId: brandId, brandName: brandName }
    }))
  }

  // Start the modal's brand picker on whatever brand was found with the duplicate search above
  prefillExistingBrand() {
    const existingBrandSelect = document.getElementById('existing_brand_id')
    if (!existingBrandSelect) return

    const searchedBrand = this.hasSearchTarget ? this.searchTarget.selectedOptions[0] : null
    existingBrandSelect.replaceChildren()
    if (searchedBrand?.value) {
      existingBrandSelect.add(new Option(searchedBrand.textContent, searchedBrand.value, true, true))
    }
    // The picker redraws its field from the select when it changes
    existingBrandSelect.dispatchEvent(new Event('change', { bubbles: true }))
  }

  openEditModal(event) {
    const dataset = event.currentTarget.dataset
    const brandId = dataset.brandId

    const form = document.getElementById('edit-brand-form')
    if (form) {
      form.action = `/brands/${brandId}`
    }

    window.dispatchEvent(new CustomEvent('open-edit-modal', {
      detail: {
        brandId,
        brandName: dataset.brandName,
        brandUrl: dataset.brandUrl || '',
        brandCountry: dataset.brandCountry || '',
        brandCrueltyFree: dataset.brandCrueltyFree === 'true',
        brandSlug: dataset.brandSlug || ''
      }
    }))
  }
}
